import { createContext, useContext } from 'react';

export interface ClassicDomainContext {
  classicDomain: string | undefined;
}

export const ClassicDomainContext = createContext<
  ClassicDomainContext | undefined
>(undefined);

export function useClassicDomain(): { classicDomain: string | undefined } {
  const context = useContext(ClassicDomainContext);
  if (!context) {
    throw new Error(
      'useClassicDomain must be used within a ClassicDomainProvider',
    );
  }

  return { classicDomain: context.classicDomain };
}
